import { FileMovedEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileMovedDetailProps = {
  event: FileMovedEvent;
};

const formatFileSize = (size: bigint): string => {
  const bytes = Number(size);
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const FileMovedDetail = ({ event }: FileMovedDetailProps) => {
  const file = event.file;
  const movedAtStr = protoTimestampToZonedDateTimeString(event.movedAt);

  if (!file) {
    return (
      <Col className="@FileMovedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FileMovedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          File Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={file.id?.value} />
          <FieldDisplay label="File Name" value={file.fileName} />
          <FieldDisplay
            label="File Size"
            value={formatFileSize(file.fileSize)}
          />
          <FieldDisplay label="MIME Type" value={file.mimeType} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Move Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="Old Parent ID" value={event.oldParentId?.value} />
          <FieldDisplay label="New Parent ID" value={file.parentId || 'Root'} />
          <FieldDisplay label="Moved By" value={event.movedBy} />
          {movedAtStr && (
            <FieldDisplay
              label="Moved At"
              value={humanReadableDateTime(movedAtStr, { locale: getLocale() })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
